<div
  class="popup-trigger"
  [matMenuTriggerFor]="menu"
  tabindex="0"
  role="button"
  aria-label="Open history status filter options"
  title="Filter options"
  style="width:24px;height:24px;min-width:24px;min-height:24px;padding:0;border:1px solid #d1d1d1;background:linear-gradient(180deg,#ffffff 0%,#e4ecf0 100%);display:inline-flex;align-items:center;justify-content:center;border-radius:2px;box-sizing:border-box;"
>
  <span class="popup-trigger-icon" aria-hidden="true" style="font-size:12px;line-height:1;color:#707070;font-weight:700;">✓</span>
</div>
<mat-menu #menu="matMenu">

  <div class='popup'>
    <label class="checkcontainer ps-5">
      <input type="checkbox" (change)="selectAllFunc(selectAll)" [(ngModel)]="selectAll">
      <span class="checkmark ms-3"></span>Select All
    </label>
    <hr>
    <li *ngFor="let item of list">
    <label class="checkcontainer ps-5">
      <input type="checkbox" (change)="this.applyFilter($event)" [(ngModel)]="item.checked">
      <span class="checkmark ms-3"></span>{{item.title}}
    </label>
    <hr>
  </li>

  </div>
</mat-menu>